/**
 * This is a script provided by Zoom required for the Zoom Virtual Agent that the customer support
 * chat widget requires. This was given via a google doc (you may need to request permission, see #autodesk_solvvy
 * slack channel for team members familiar with the integration)
 * https://docs.google.com/document/d/12i_OEAld0iqu7nY-1_8q2vIi6mIFKZgYUGQk0sCJv10/edit#heading=h.ii1ektxp7bjl
 *
 * The provided code was converted to typescript.
 */
function zvaInitScript() {
  var _embedded_svc;
  //Add if you need to hide Salesforce widget
  // @ts-expect-error - This code is from a 3rd party source, leaving as is as it seems to work
  (_embedded_svc = embedded_svc) === null || _embedded_svc === void 0 ? void 0 : _embedded_svc.hideHelpButton();
  //ZVA Chat By Event Script passing transcript, URL and Origin
  window.addEventListener('support_handoff', e => {
    // @ts-expect-error - This code is from a 3rd party source, leaving as is as it seems to work
    localStorage.setItem('isChatting', true);
    // @ts-expect-error - This code is from a 3rd party source, leaving as is as it seems to work
    const origin = e.detail.tags[0];
    // @ts-expect-error - This code is from a 3rd party source, leaving as is as it seems to work
    const sendTranscript = e.detail.transcript.map(entry => {
      if (entry.kmResponse) {
        return "".concat(entry.from, ": ").concat(entry.kmResponse.title, ", ").concat(entry.kmResponse.url).replace(/\n/g, '');
      }
      return "".concat(entry.from, ": ").concat(entry.message).replace(/\n/g, '');
    }).join('\n');
    const chatCase = {
      label: 'Chat Case',
      displayToAgent: true,
      transcriptFields: [],
      value: origin.value
    };
    const urlInfo = {
      label: 'URL From Form',
      displayToAgent: true,
      transcriptFields: [],
      value: window.location.href
    };
    const userJourney = {
      label: 'Customer Journey',
      displayToAgent: true,
      transcriptFields: [],
      value: sendTranscript
    };
    document.querySelector('.embeddedServiceHelpButton button').click();
    setTimeout(() => window.zoomCampaignSdk.hide(), 5000);
    if (window.embedded_svc.settings.extraPrechatFormDetails === undefined) {
      window.embedded_svc.settings.extraPrechatInfo = [{
        entityFieldMaps: [{
          doCreate: true,
          doFind: false,
          fieldName: 'URLFromForm__c',
          isExactMatch: true,
          label: 'URL From Form'
        }, {
          doCreate: true,
          doFind: false,
          fieldName: 'Comments',
          isExactMatch: true,
          label: 'Customer Journey'
        }, {
          doCreate: true,
          doFind: false,
          fieldName: 'SolvvyWorkflow__c',
          isExactMatch: true,
          label: 'Customer Journey'
        }, {
          doCreate: true,
          doFind: false,
          fieldName: 'Origin',
          isExactMatch: true,
          label: 'Chat Case'
        }],
        entityName: 'Case'
      }];
      window.embedded_svc.settings.extraPrechatFormDetails = [urlInfo, userJourney, chatCase];
    } else {
      let URLDetailDefined = false;
      window.embedded_svc.settings.extraPrechatFormDetails.forEach(el => {
        if (el.label === 'URL From Form') {
          URLDetailDefined = true;
        }
      });
      if (!URLDetailDefined) {
        window.embedded_svc.settings.extraPrechatInfo = [{
          entityFieldMaps: [{
            doCreate: true,
            doFind: false,
            fieldName: 'URLFromForm__c',
            isExactMatch: true,
            label: 'URL From Form'
          }, {
            doCreate: true,
            doFind: false,
            fieldName: 'Comments',
            isExactMatch: true,
            label: 'Customer Journey'
          }, {
            doCreate: true,
            doFind: false,
            fieldName: 'SolvvyWorkflow__c',
            isExactMatch: true,
            label: 'Customer Journey'
          }, {
            doCreate: true,
            doFind: false,
            fieldName: 'Origin',
            isExactMatch: true,
            label: 'Chat Case'
          }],
          entityName: 'Case'
        }];
        window.embedded_svc.settings.extraPrechatFormDetails.push(urlInfo, userJourney, chatCase);
      }
    }
    function call() {
      const embeddedContainer = document.getElementsByTagName('embeddedservice-chat-header')[0];
      setTimeout(() => {
        if (embeddedContainer) {
          embeddedContainer.getElementsByClassName('closeButton')[0].addEventListener('click', () => {
            window.embedded_svc.liveAgentAPI.endChat();
            // @ts-expect-error - This code is from a 3rd party source, leaving as is as it seems to work
            localStorage.setItem('isChatting', false);
            window.zoomCampaignSdk.show();
            window.zoomCampaignSdk.close();
          });
        } else {
          call();
        }
      }, 2000);
    }
    call();
  });
}
export default zvaInitScript;
//# sourceMappingURL=zvaInitScript.js.map